// 展开一级时只自动展开第一个二级分组（Figma 终版：BY CATEGORY 展开，其余收起）
//
// 必须用事件委托：抽屉正文现在装在 <template> 里，点汉堡时才由 global.js 的
// MenuDrawer.hydrateContent() 搬进 DOM，脚本加载那一刻这个选择器一个元素都选不到。
// 委托到 document 不改变行为 —— 原来直绑在 summary 上，处理器同样在
// <details> 的默认动作（切换 open）之前跑，所以下面读 $details.attr('open')
// 拿到的仍是"点击之前"的状态。
$(document).on('click', '.menu-drawer__navigation > ul > li > details > summary', function () {
  var $details = $(this).closest('details');
  if ($details.attr('open')) return;
  $details.find('> div details:not(:has(a[href="#"]))').first().attr('open', true);
});
$('header-drawer').on('click', function (event) {
  // 关闭菜单图标的程序化 click 也会冒泡到这里，不能把刚打开的购物车再次关闭。
  if (event.target.closest('.header__modal-close-button')) return;
  if ($('.drawer').hasClass('active')) {
    $('.drawer__close').click();
  }
  if ($('#search-modal').hasClass('active')) {
    $('.search__close').click();
  }
});
$('.header-wrapper .searchBox').on('click', function () {
  const trigger = document.querySelector('#search-icon-open');
  if (trigger) {
    trigger.click();
    const modal = document.querySelector('search-modal');
    if (modal) modal.setActiveElement(this);
  } else {
    const searchLink = document.querySelector('.header__search a');
    if (searchLink) searchLink.click();
  }
})
$('.header-wrapper .searchBox').on('keydown', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  if (!event.repeat) this.click();
});
$('.header__search').on('click', function () {
  if ($('#menu-drawer').css('visibility') == 'visible') {
    $('.header__modal-close-button').click();
  }
  if ($('.drawer').hasClass('active')) {
    $('.drawer__close').click();
  }
})
$('.header__cart').on('click', function () {
  if ($('#menu-drawer').css('visibility') == 'visible') {
    $('.header__modal-close-button').click();
  }
  if ($('#search-modal').hasClass('active')) {
    $('.search__close').click();
  }
});

// 打开动画完成前焦点仍在账户入口，Escape 也要交给抽屉原有的关闭和取消动画逻辑。
$(document).on('keyup', '#account-icon-open', function (event) {
  if (event.key !== 'Escape') return;
  const modal = document.querySelector('account-modal.active');
  if (!modal || typeof modal.close !== 'function') return;
  event.preventDefault();
  modal.close();
});

// 导航已合并为单行，不再随滚动隐藏第一行

// 菜单未展开时不挂载图片；鼠标/键盘/触屏进入对应菜单即提前请求，保留原图片尺寸和选档。
(function () {
  function loadMenuImages(event) {
    const item = event.target.closest && event.target.closest('.header__inline-menu li');
    if (!item) return;
    item.querySelectorAll('template[data-nav-image]').forEach(template => {
      template.replaceWith(template.content.cloneNode(true));
    });
  }
  ['pointerover', 'focusin', 'touchstart'].forEach(type => {
    document.addEventListener(type, loadMenuImages, { passive: true });
  });
  document.querySelectorAll('.header__inline-menu li:hover').forEach(item => loadMenuImages({ target: item }));
})();

// 应用先插入按钮、后加载样式。保留占位到按钮的关键布局样式就绪，再交还自然宽度。
(function () {
  const slot = document.getElementById('glc-switcher-manual-desktop');
  if (!slot || slot.hasAttribute('data-layout-ready')) return;
  let frame = 0;
  const observer = new MutationObserver(schedule);
  function schedule() {
    if (!frame) frame = requestAnimationFrame(check);
  }
  function check() {
    frame = 0;
    const button = slot.querySelector('.glc-switcher-btn');
    const label = slot.querySelector('.glc-switcher-btn__name');
    if (!button || !label) return;
    const buttonStyle = getComputedStyle(button);
    const labelStyle = getComputedStyle(label);
    if (!['flex', 'inline-flex'].includes(buttonStyle.display) || buttonStyle.paddingRight !== '28px' ||
        labelStyle.fontSize !== '14px' || labelStyle.lineHeight !== '20px') return;
    slot.setAttribute('data-layout-ready', '');
    observer.disconnect();
    document.removeEventListener('load', schedule, true);
  }
  observer.observe(slot, { childList: true, subtree: true, attributes: true });
  observer.observe(document.head, { childList: true, subtree: true });
  document.addEventListener('load', schedule, true);
  schedule();
})();

// 应用按钮已有可见语言/货币文字时，使用内容命名；保留原节点和应用交互。
// 桌面挂载点，以及应用内嵌在手机页头左侧的按钮（只显示语言）。
(function () {
  const scopes = [
    [document.getElementById('glc-switcher-manual-desktop'), '.glc-dropdown-btn.glc-switcher-btn[role="button"]'],
    [document.querySelector('.menuTop__start'), '.glc-dropdown-btn.glc-switcher-btn.glc-switcher-btn--embedded-mobile[role="button"]']
  ].filter(([root]) => root);
  if (!scopes.length) return;
  let frame = 0;
  function schedule() {
    if (!frame) frame = requestAnimationFrame(syncNames);
  }
  function syncNames() {
    frame = 0;
    scopes.forEach(([root, selector]) => root.querySelectorAll(selector).forEach(button => {
      // 保留其它命名和外部 label；纯图标版本不能失去唯一名称。
      if (button.getAttribute('aria-label') !== 'Change Switcher' ||
          button.hasAttribute('aria-labelledby')) return;
      const content = button.querySelector('.glc-switcher-btn__content');
      if (!content || !content.innerText.trim()) return;
      // 让现有可见文字提供名称，不改应用节点、状态或事件。
      button.removeAttribute('aria-label');
    }));
  }
  const observer = new MutationObserver(schedule);
  scopes.forEach(([root]) => observer.observe(root, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['aria-label', 'aria-labelledby']
  }));
  schedule();
})();

// 只移除应用已生成面板却仍悬空的已知可选引用，不伪造或修改应用面板。
(function () {
  const slot = document.getElementById('glc-switcher-manual-desktop');
  if (!slot) return;
  const selector = '.glc-dropdown-btn.glc-switcher-btn.glc-switcher-btn--embedded-desktop[role="button"][aria-controls="switcher-selector"]';
  let frame = 0;
  function schedule() {
    if (slot.isConnected && !frame && slot.querySelector(selector)) frame = requestAnimationFrame(syncControls);
  }
  function syncControls() {
    frame = 0;
    if (document.getElementById('switcher-selector')) return;
    const owners = window._gelacy?.switchers;
    if (!Array.isArray(owners)) return;
    slot.querySelectorAll(selector).forEach(button => {
      const matches = owners.filter(owner => owner && owner.button === button);
      if (matches.length !== 1) return;
      const expand = matches[0].expand;
      if (!(expand instanceof Element) || !expand.isConnected ||
          expand.ownerDocument !== document || !expand.classList.contains('glc-dropdown-expand')) return;
      button.removeAttribute('aria-controls');
    });
  }
  const observer = new MutationObserver(schedule);
  observer.observe(slot, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['aria-controls', 'class', 'role']
  });
  // 面板由应用放在 body，晚于按钮连接；只观察节点连接，不读取或改写应用内部状态。
  observer.observe(document.body, { childList: true, subtree: true });
  schedule();
})();
